@if (!loadingOffice) {
  <div class="mt-2">
    <h3>Office Details Change Log: {{ office.name }}</h3>
    @if (!loadingAudits) {
      <div>
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'audits'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <div class="audit-list-wrapper col-12">
          <table class="audit-list table table-bordered table-hover">
            <thead class="table-dark">
              <tr>
                <th>Changed At</th>
                <th>Action</th>
                <th>New Values</th>
                <th>Previous Values</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              @for (audit of audits; track audit) {
                @if (audit.auditableType === 'Office' && audit.action === 'create') {
                  <tr
                    app-audit-office-create-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'Office' && audit.action === 'update') {
                  <tr
                    app-audit-office-update-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'Note' && audit.action === 'create') {
                  <tr
                    app-audit-note-create-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'ProviderOffice' && audit.action === 'create') {
                  <tr
                    app-audit-provider-office-create-row
                    [audit]="audit"
                  [displayNpi]="true"></tr>
                }
                @if (audit.auditableType === 'ProviderOffice' && audit.action === 'update') {
                  <tr
                    app-audit-provider-office-update-row
                    [audit]="audit"
                  [displayNpi]="true"></tr>
                }
              }
            </tbody>
          </table>
          <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        </div>
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
  </div>
} @else {
  <mat-spinner diameter="30" />
}
